export default {
  STAGES: (state, stages) => { state.stages = stages },
  ROWS: (state, rows) => { state.rows = rows },
  BOARD_NAME: (state, boardName) => { state.boardName = boardName },
  EVENTS: (state, events) => { state.events = events },
  SET_FILTER: (state, filters) => {
    Object.assign(state.filters, filters)
  },
  SET_FILTER_META: (state, filters) => {
    const st = { ...state.filters, ...filters }
    state.filters = st
  },
  SET_FILTER_STAGE: (state, stage) => { state.filters.stage = stage }
}



// WEBPACK FOOTER //
// ./src/view/board/state/mutations.js